import calendar from './calendar';

export default {
    ...calendar,
};
